/**
 * ADR-0013 — Profit Owner (Finance).
 *
 * ADR-0016 Phase 3: Report-Normalpfad liest frozen sale COGS (costSnapshot /
 * inventoryCostFrozen). FIFO-Lot-Recalc nur noch Legacy-Fallback / Recovery.
 *
 * Cuisine stockConsumptions.totalCost zählt zu COGS.
 * Fallback ohne Lots und ohne frozen: Purchase-Totals nur wenn Sales existieren.
 *
 * Periodenfilter: Aufrufer filtert sales/purchases/expenses/stockConsumptions.
 */

import CalculationFactory from '../../services/calculationFactory';
import { summarizeRevenue } from './revenue';

/**
 * @param {object} params
 * @param {Array} [params.sales]
 * @param {Array} [params.purchases]
 * @param {Array} [params.expenses]
 * @param {Array|object} [params.lots]
 * @param {Array} [params.stockConsumptions]
 * @returns {{
 *   revenue: number,
 *   purchaseCosts: number,
 *   operatingExpenses: number,
 *   netProfit: number,
 *   profitMargin: number,
 *   totalCosts: number,
 *   costSource: string,
 *   salesCount: number,
 *   averageOrderValue: number
 * }}
 */
export function calculateProfit({
  sales = [],
  purchases = [],
  expenses = [],
  lots = [],
  stockConsumptions = []
} = {}) {
  const lotsArray = Array.isArray(lots) ? lots : Object.values(lots || {});
  const result = CalculationFactory.calculateProfit(
    sales || [],
    purchases || [],
    expenses || [],
    lotsArray,
    stockConsumptions || []
  );
  // Revenue SSOT = getSaleTotalAmount (Restaurant-aware); COGS prefers frozen sale facts
  const { totalRevenue, salesCount, averageOrderValue } = summarizeRevenue(sales || []);
  const netProfit = totalRevenue - result.purchaseCosts - result.operatingExpenses;
  const profitMargin = totalRevenue > 0 ? (netProfit / totalRevenue) * 100 : 0;

  return {
    ...result,
    revenue: totalRevenue,
    netProfit,
    profitMargin,
    totalCosts: result.purchaseCosts + result.operatingExpenses,
    salesCount,
    averageOrderValue
  };
}
